import dayjs from 'dayjs';
import React from 'react';

const ChatbotOverview = ({key_info}) => {
  if (!key_info) return null;

  const {
    city,
    guest_count,
    total_budget,
    wedding_date,
  } = key_info;

  return (
    <div className='overview-container'>
      <div className='overview-item'>
        <div className='label'>Date</div>
        <div className='value'>{wedding_date && dayjs(wedding_date).format('MMM D, YYYY')}</div>
      </div>
      <div className='overview-item'>
        <div className='label'>Location</div>
        <div className='value'>{city}</div>
      </div>
      <div className='overview-item'>
        <div className='label'>Guest Count</div>
        <div className='value'>{guest_count}</div>
      </div>
      <div className='overview-item'>
        <div className='label'>Budget</div>
        <div className='value'>{total_budget}</div>
      </div>
    </div>
  )
}

export default ChatbotOverview;